// @flow
import type { DataField } from "../../lib/Types";
import React from "react";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";

type Props = {
  data_field: DataField,
  fullWidth: boolean,
  onCtrlDown: Function,
  gridCol: ?string,
};

const Input = styled.input.attrs({
  type: "text",
  placeholder: props => (props.required ? "Required..." : "")
})`
  min-width: 80px;
  width: ${props => (props.fullWidth ? "90%" : "80px")};
  padding-left: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  ${props =>
    props.fullWidth &&
    css`
      padding: 10px;
    `};
  vertical-align: middle;
  border: ${props => (props.fullWidth ? "1px solid #DDD" : "0px;")};
  background-color: ${props => (props.required ? !props.value && "#FFBBBB" : "inherit")};
  ${props =>
    props.highlighted &&
    css`
      background-color: #ecffa4;
      color: #ecffa4;
    `};
`;

class NumberInput extends React.Component<Props> {
  updateValue = event => {
    var value = event.target.value;
    if (/^(\d+|\.)*$/.test(value)) {
      this.props.data_field.value = value;
    }
  };

  _handleKeyDown = e => {
    const { onCtrlDown, onCtrlUp } = this.props;
    if (e.ctrlKey && e.keyCode === 68) {
      console.log("Ctrl + Down pressed");
      onCtrlDown && onCtrlDown();
      e.preventDefault();
    }
  };

  render() {
    const {
      fullWidth,
      data_field: { value, mandatory, highlighted },
      onFocus,
      gridCol,
    } = this.props;
    return (
      <Input
        value={value}
        required={mandatory}
        onChange={this.updateValue}
        fullWidth={fullWidth}
        highlighted={highlighted}
        onFocus={onFocus}
        style={{ flex: 1 }}
        onKeyDown={this._handleKeyDown}
        data-sample-grid-col={gridCol}
      />
    );
  }
}

export default observer(NumberInput);
